import { AdminListView } from "./AdminListView";
import { productAdapter } from "./productAdapter";

export function ProductAdminPage() {
  return <AdminListView adapter={productAdapter} />;
}
